import { useEffect, useCallback } from "react";
import api from "../utils/api";
import { CHAVE_TOKEN } from "../utils/formata";

export default function useLead() {
  // Mesmo padrão do useHelp: garante o Bearer no F5 direto em /prospeccao,
  // antes do effect de carregamento da página (effects rodam na ordem de registro)
  useEffect(() => {
    const token = localStorage.getItem(CHAVE_TOKEN);
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }
  }, []);

  // Sem try/catch: o erro do axios sobe com .status/.response,
  // que é o shape que o useErroPadrao espera pra mostrar a mensagem do backend
  const cadastrarLead = useCallback(async (dados) => {
    return api.post("/lead", dados).then((r) => r.data);
  }, []);

  const listarLeads = useCallback(async () => {
    return api.get("/lead").then((r) => r.data.leads);
  }, []);

  const getLeadById = useCallback(async (id) => {
    return api.get(`/lead/${id}`).then((r) => r.data.lead);
  }, []);

  const atualizarLead = useCallback(async (id, dados) => {
    return api.put(`/lead/${id}`, dados).then((r) => r.data);
  }, []);

  const deletarLead = useCallback(async (id) => {
    return api.delete(`/lead/${id}`).then((r) => r.data);
  }, []);

  const importarLeads = useCallback(async (lista) => {
    return api.post("/lead/importar", { leads: lista }).then((r) => r.data);
  }, []);

  const selecionarLeads = useCallback(async (ids, selecionado) => {
    return api.post("/lead/selecionar", { ids, selecionado }).then((r) => r.data);
  }, []);

  const pedirDisparo = useCallback(async (quantos) => {
    return api.post("/lead/disparo", { quantos }).then((r) => r.data);
  }, []);

  const buscarNoCristal = useCallback(async (filtros) => {
    return api.post("/lead/cristal", filtros).then((r) => r.data);
  }, []);

  const configProspeccao = useCallback(async () => {
    return api.get("/lead/config").then((r) => r.data.config);
  }, []);

  const enviarTesteProspeccao = useCallback(async (telefone, nome) => {
    return api.post("/lead/teste", { telefone, nome }).then((r) => r.data);
  }, []);

  const salvarConfigProspeccao = useCallback(async (dados) => {
    return api.put("/lead/config", dados).then((r) => r.data);
  }, []);

  return {
    cadastrarLead,
    listarLeads,
    getLeadById,
    atualizarLead,
    deletarLead,
    importarLeads,
    selecionarLeads,
    pedirDisparo,
    buscarNoCristal,
    enviarTesteProspeccao,
    configProspeccao,
    salvarConfigProspeccao,
  };
}
